import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import React, {
  forwardRef, useMemo,
} from 'react';

export type InputMultiSelectClasses = {
  group?: string;
  input?: string;
  label?: string;
}

export type InputMultiSelectProps = {
  id?: string;
  name: string;
  label: string;
  classes?: InputMultiSelectClasses;
  error?: string;
  getOptionValue?: (value: any) => void;
  onChange: (value: any) => void;
} & Omit<MultiSelectProps, 'onChange'>;

const defaultValue = (option: any) => option?.id;

const InputMultiSelect = forwardRef<MultiSelect, InputMultiSelectProps>(
  (
    {
      id,
      name,
      label,
      classes,
      placeholder,
      error,
      onChange,
      value,
      ...props
    },
    ref
  ) => {
    const optionsValue = props.getOptionValue ? props.getOptionValue : defaultValue;

    const values = props.options?.filter(option => value?.includes(optionsValue(option)));

    return (
      <div className={classNames('flex flex-column mb-3', classes?.group, { 'p-error': error })}>
        <label
          htmlFor={name}
          className={classNames(['font-medium mb-1', classes?.label])}>{label}</label>
        <MultiSelect
          id={id}
          name={name}
          ref={ref}
          aria-label={label}
          placeholder={placeholder}
          options={props.options}
          value={values}
          className={classNames({ 'is-invalid': error }, classes?.input)}
          onChange={(event) => {
            onChange(event.value.map(optionsValue))
          }}
          {...props}
        />

        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  }
);

InputMultiSelect.displayName = 'InputMultiSelect';

export {
  InputMultiSelect
};
